const checkIfObjectEmpty = (obj: Record<string | number, unknown>): boolean =>
  !Object.keys(obj).length;

const checkIfEntityClasicObj = (entity: unknown): boolean =>
  !!entity && typeof entity === 'object' && !Array.isArray(entity);

const checkIfEntityObj = (
  entity: unknown,
): entity is Partial<Record<string | number | symbol, unknown>> =>
  !!entity && typeof entity === 'object' && !Array.isArray(entity);

export { checkIfEntityClasicObj, checkIfEntityObj, checkIfObjectEmpty };
